import getFirebase from './firebase';

import {
  getFirestore,
  Timestamp,
  // setDoc,
  collection,
  addDoc,
  // doc
} from 'firebase/firestore/lite';

const nav = window.navigator;
const user = {};
for (let prop in nav) {
  const val = nav[prop];
  if (['string', 'number'].includes(typeof val)) {
    user[prop] = val;
  }
}

const storage = window.localStorage ?? {};

let getFirestoreInstance = async () => {
  const firebase = await getFirebase();
  const firestore = getFirestore(firebase);
  getFirestoreInstance = async () => firestore;
  return firestore;
};

let getStatsDB = async () => {
  const fs = await getFirestoreInstance();
  return collection(fs, 'profile-page-logs');
};

// const firestore = getFirestore(firebase);
// const statsDB = collection(firestore, 'profile-page-logs');

async function addPageLog(data) {
  const statsDB = await getStatsDB();
  try {
    await addDoc(statsDB, data);
  }
  catch (err) {
    console.error('@SPNSRS log write error');
    console.error(err);
  }
}

const getViewKey = banner => {
  const {
    brandId, campaignId
  } = banner;
  return `@SPNSRS/brand/${brandId}/campaign/${campaignId}`
};

const saveView = banner => {
  // only once
  if (hasView(banner)) return;

  const key = getViewKey(banner);
  storage.setItem(key, 1);
  addPageLog({
    banner,
    user,
    action: 'page-view',
    timestamp: Timestamp.now()
  });
};

const hasView = banner => {
  const key = getViewKey(banner);
  return storage.getItem(key) ? true : false;
};

const BANNER_DESC_TEXT_CLASS = 'spnsrs-banner-description-text';

export default function bannerHandler(banner) {

  // const localData = {
  //   bannerId: banner.bannerId,
  //   brandId: banner.brandId,
  //   campaignId: banner.campaignId
  // };

  const visibleObserver = new IntersectionObserver(onVisible, {
    root: null,
    threshold: 0.99
  });

  async function onVisible(entries) {
    const visible = entries.find(e => e.isIntersecting);
    if (!visible) return;

    // a reach
    saveView(banner);

    // an impression
    await addPageLog({
      banner,
      user,
      action: 'banner-visible',
      timestamp: Timestamp.now()
    });
  }

  window.addEventListener('load', () => {
    visibleObserver.observe(this.$el);
  });

  const result = {
    init () {
      this.showMore = false;
      this.showLess = null;
    },
    onDescriptionInit (e) {
      this.showMore = e.scrollHeight > e.clientHeight;
      this.showLess = this.showMore === true ? false : null;

      this.descriptionHeight = `${e.clientHeight}px`;
      this.descriptionEl = e;
    },
    imageLoaded () {
      // console.log('@SPNSRS BANNER IMAGE LOADED:', banner.name);
    },
    async urlClick (e) {
      // console.log('URL CLICK', e);
      // e.preventDefault();
      await addPageLog({
        banner,
        user,
        action: 'click-url',
        timestamp: Timestamp.now()
      });
    },
    seeMoreClick (e) {
      // this.descriptionEl.style.height = '100%';
      this.descriptionEl.classList.remove(BANNER_DESC_TEXT_CLASS);
      this.showLess = true;
      this.showMore = false;
      e.preventDefault();
    },
    seeLessClick (e) {
      // this.descriptionEl.style.height = this.descriptionHeight;
      this.descriptionEl.classList.add(BANNER_DESC_TEXT_CLASS);
      this.showLess = false;
      this.showMore = true;
      e.preventDefault();
    }
  };

  return result;
};